import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Divider, Flex, Menu, MenuButton, MenuItem, Text } from '@aws-amplify/ui-react'
import { Logo } from './static/Logo'
import { HelpMenu } from './Layout'

export interface DesktopNavProps {
    authStatus: string
    userDisplayName: string
    onSignOut: () => void
}

export function DesktopNav({ authStatus, userDisplayName, onSignOut }: DesktopNavProps) {
    const navigate = useNavigate()

    return (
        <Flex alignItems={'center'}
            justifyContent={"center"}
            wrap="wrap"
            className="desktop-nav"
        >
            <Logo />
            <Button variation='menu' onClick={() => navigate('/pricing')}>Pricing</Button>
            <HelpMenu />
            <Button variation='menu' onClick={() => navigate('/contribute')}>Contribute</Button>
            <Button variation='menu' onClick={() => navigate('/makemoney')}>Make Money</Button>
            {authStatus !== 'authenticated' ? (
                <Button onClick={() => navigate('/login')}>Sign In</Button>
            ) : (
                <>
                    <Menu
                        trigger={
                            <MenuButton>
                                {userDisplayName}
                            </MenuButton>
                        }
                    >
                        <MenuItem onClick={() => navigate('/referral')}>Referral Program</MenuItem>
                        <MenuItem onClick={() => navigate('/password')}>Password Change</MenuItem>
                        <MenuItem variation='warning' onClick={onSignOut}>
                            <Text variation='warning'>Logout</Text>
                        </MenuItem>
                        <Divider />
                        <MenuItem variation='destructive' onClick={() => navigate('/unregister')}>
                            <Text variation='error'>Delete Your Account</Text>
                        </MenuItem>
                    </Menu>
                </>
            )}
        </Flex>
    )
}
